import { render, staticRenderFns } from "./VerifyPasswordReset.vue?vue&type=template&id=50b5abb1&scoped=true&"
import script from "./VerifyPasswordReset.vue?vue&type=script&lang=js&"
export * from "./VerifyPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPasswordReset.vue?vue&type=style&index=0&id=50b5abb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5abb1",
  null
  
)

export default component.exports